module.exports = __webpack_public_path__ + "img/3f_l_newtokyo@2x.83a459c5.png";